/*
 * @Author: mayanxia 
 * @Date: 2023-03-08 19:22:37 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2023-07-26 11:15:27
 */


<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    :bodyStyle="bodyStyle"
    :cancelText="$t('关闭')">
    <template slot="footer">
      <a-button key="close" @click="handleCancel">
        {{ $t('关闭') }}
      </a-button>
    </template>
    <a-spin :spinning="confirmLoading">
       <div class="form-contain" style="height: auto">
        <a-tabs v-model="activeKey" @change="changeTab">
          <a-tab-pane v-for="item in tabList" :key="item.key" :tab="item.title">
            <div v-if="activeKey == 1" style="height: calc(70vh - 90px);overflow-y: auto;">
              <detail-list :col="2" size="small">
                <detail-list-item :term="$t('设备名称')">{{model.deviceName}}</detail-list-item>
                <detail-list-item :term="$t('设备编号')">{{model.meterId}}</detail-list-item>
                <detail-list-item :term="$t('安装位置')">{{model.deviceLocation}}</detail-list-item>
                <detail-list-item :term="$t('上传时间')">{{model.sysTime}}</detail-list-item>
                <detail-list-item :term="$t('PH值')">{{model['w01001-Rtd'] | isEffectiveFilter}}</detail-list-item>
                <detail-list-item :term="$t('色度')">{{model['w01002-Rtd'] | isEffectiveFilter}}</detail-list-item>
                <detail-list-item :term="$t('浑浊度(NTU)')">{{model['w01003-Rtd'] | isEffectiveFilter}}</detail-list-item>
                <detail-list-item :term="$t('溶解性总固体(mg/L)')">{{model['w01006-Rtd'] | isEffectiveFilter}}</detail-list-item>
                
                
                <detail-list-item :term="$t('硬度(mg/L)')">{{model['w10000-Rtd'] | isEffectiveFilter}}</detail-list-item>
                <detail-list-item term="ORP(mv)">{{model['w10001-Rtd'] | isEffectiveFilter}}</detail-list-item>
                <detail-list-item :term="$t('氯化物(mg/L)')">{{model['w21022-Rtd'] | isEffectiveFilter}}</detail-list-item>
                <detail-list-item :term="$t('余氯(mg/L)')">{{model['w21024-Rtd'] | isEffectiveFilter}}</detail-list-item>
                <detail-list-item :term="$t('硫酸盐(mg/L)')">{{model['w21038-Rtd'] | isEffectiveFilter}}</detail-list-item>
                <detail-list-item :term="$t('温度值(℃)')">{{model['w01010-Rtd'] | isEffectiveFilter}}</detail-list-item>
                <detail-list-item :term="$t('电导率(μS/cm)')">{{model['w01014-Rtd'] | isEffectiveFilter}}</detail-list-item>

                <detail-list-item :term="$t('PH电极通讯状态')" v-if="model['w01001-Ecs']">{{ eCStatusFilter(model['w01001-Ecs']) }}</detail-list-item>
                <detail-list-item :term="$t('氯化物电极通讯状态')" v-if="model['w21022-Ecs']">{{ eCStatusFilter(model['w21022-Ecs']) }}</detail-list-item>
                <detail-list-item :term="$t('余氯电极通讯状态')" v-if="model['w21024-Ecs']">{{ eCStatusFilter(model['w21024-Ecs']) }}</detail-list-item>
                <detail-list-item :term="$t('浊度电极通讯状态')" v-if="model['w01003-Ecs']">{{ eCStatusFilter(model['w01003-Ecs']) }}</detail-list-item>
                <detail-list-item :term="$t('电导率电极通讯状态')" v-if="model['w01014-Ecs']">{{ eCStatusFilter(model['w01014-Ecs']) }}</detail-list-item>
                
                <detail-list-item :term="$t('PH报警状态')" v-if="model['w01001-Ews']">{{ eWStatusFilter(model['w01001-Ews']) }}</detail-list-item>
                <detail-list-item :term="$t('氯化物报警状态')" v-if="model['w21022-Ews']">{{ eWStatusFilter(model['w21022-Ews']) }}</detail-list-item>
                <detail-list-item :term="$t('余氯报警状态')" v-if="model['w21024-Ews']">{{ eWStatusFilter(model['w21024-Ews']) }}</detail-list-item>
                <detail-list-item :term="$t('浊度报警状态')" v-if="model['w01003-Ews']">{{ eWStatusFilter(model['w01003-Ews']) }}</detail-list-item>
                <detail-list-item :term="$t('电导率报警状态')" v-if="model['w01014-Ews']">{{ eWStatusFilter(model['w01014-Ews']) }}</detail-list-item>

                <detail-list-item :term="$t('缺水状态')" v-if="model['lackWaterStatus']">{{ lackWaterStatusFilter(model['lackWaterStatus']) }}</detail-list-item>
              </detail-list>
            </div>
            <a-table
              v-else-if="activeKey != 1"
              ref="table"
              size="middle"
              :scroll="{y:'calc(70vh - 300px)',x:true}"
              bordered
              rowKey="id"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="ipagination"
              :loading="loading"
              class="j-table-force-nowrap"
              @change="handleTableChange"
              >
            </a-table>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-spin>
  </j-modal>
</template>

<script>

  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import {filterDictTextByCache} from '@/components/dict/JDictSelectUtil'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {isUndefined} from'@/utils/validate'

  export default {
    name: 'EmfFlowUpDataLastRecordModal',
    mixins:[JeecgListMixin],
    components: {
      DetailList,
      DetailListItem
    },
    filters: {
      'isEffectiveFilter': function (value) {

        if(isUndefined(value)){
          return '--'
        }else{
          return value
        }
      }
    },
    data () {
      return {
        bodyStyle: {
          height: '60vh',
          'overflow-y': 'hidden'
        },
        width:800,
        visible: false,
        disableSubmit: false,
        model: {},
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/jeecg-charge/wq/partWellElecControllLastRecord/add",
          edit: "/jeecg-charge/wq/partWellElecControllLastRecord/edit",
          queryById: "/jeecg-charge/wq/partWellElecControllLastRecord/queryById",
          list: "/jeecg-charge/wq/partWellElecControllLastRecord/list"
        },
        meterSignal: {},
        activeKey: 1,
        disableMixinCreated: true,
        uniqueParam: {},
      }
    },
    computed: {
      title() {
        return this.$t('详情')
      },
      tabList() {
        return [
          {key: 1,title: this.$t('基本信息')},
          //{key: 2,title: '历史数据'}
        ]
      },
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('设备编号'),
            align:"center",
            dataIndex: 'meterId'
          },/*{
            title:'设备名称',
            align:"center",
            dataIndex: 'deviceName'
          },{
            title:'安装位置',
            align:"center",
            dataIndex: 'deviceLocation'
          },*/
          {
            title: this.$t('压力值(MPa)'),
            align:"center",
            dataIndex: 'pvalue'
          },
          {
            title: this.$t('温度值(℃)'),
            align:"center",
            dataIndex: 'tepvalue'
          },
          {
            title: this.$t('总累计流量(m³)'),
            align:"center",
            dataIndex: 'throughputTotal'
          },
          {
            title: this.$t('正向流量(m³)'),
            align:"center",
            dataIndex: 'throughput'
          },
          {
            title: this.$t('反向流量(m³)'),
            align:"center",
            dataIndex: 'throughputMinus'
          },
          {
            title: this.$t('上报时间'),
            align:"center",
            dataIndex: 'sysTime'
          }
        ]
      },
      meterTypeName() {
        if(this.model.meterType) {
          let meterType = parseInt(this.model.meterType).toString(16)
          return  filterDictTextByCache('valve_device_type',meterType);
        }
        
      }
    },
    created () {
    },
    methods: {
      eCStatusFilter (status) {
        // 电极通讯状态
        var str = ''
        if(status!==""){
          status = parseInt(status)
        }else{
          return str
        }
        switch(status){
          case 0:
          str = this.$t('正常')
          break;
          case 1:
          str = this.$t('异常')
          break;
          default:
          str = '--'
          break;
        }
        return str
      },
      lackWaterStatusFilter (status) {
        // 缺水状态
        var str = ''
        if(status!==""){
          status = parseInt(status)
        }else{
          return str
        }
        switch(status){
          case 0:
          str = this.$t('正常')
          break;
          case 1:
          str = this.$t('缺水')
          break;
          default:
          str = '--'
          break;
        }
        return str
      },
      eWStatusFilter (status) {
        // 告警状态
        var str = ''
        if(status!==""){
          status = parseInt(status)
        }else{
          return str
        }
        switch(status){
          case 0:
          str = this.$t('正常')
          break;
          case 1:
          str = this.$t('高报')
          break;
          case 1:
          str = this.$t('低报')
          break;
          default:
          str = '--'
          break;
        }
        return str
      },
      close () {
        this.$emit('close');
        this.activeKey = 1;
        this.visible = false;
      },
      add () {
        this.edit({});
      },
      edit (record) {
        
        this.model = Object.assign({}, record);
        this.uniqueParam.deviceId = this.model.meterId
        this.visible = true;
      },
      handleOk () {
        const that = this;
      },
      handleCancel () {
        this.close()
      },
      changeTab() {
        if(this.activeKey == 2) {
          this.loadData(1)
        }
      }
    }
  }
</script>
<style scoped>
.detail-list >>> .term{
  line-height: 22px;
}
</style>